import { createModel } from '@rematch/core'
// import * as faker from 'faker'
import * as firebase from 'firebase'
import * as moment from 'moment'
import { store } from 'src/store'

// const mockDiscussions = [
//   {
//     id: 'mock-discussion-0',
//     ts: moment(faker.date.recent()),
//     text: '對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維',
//     authorId: 'mock-user-0',
//     reactions: {
//       love: ['mock-user-0', 'mock-user-1']
//     },
//     replies: [
//       {
//         id: 'mock-reply-0',
//         ts: moment(faker.date.recent()),
//         text:
//           'RE: 對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維',
//         authorId: 'mock-user-0',
//         reactions: {
//           love: ['mock-user-0', 'mock-user-1']
//         },
//         revisions: [
//           {
//             ts: moment(faker.date.recent()),
//             text:
//               '[0] RE: 對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維'
//           },
//           {
//             ts: moment(faker.date.recent()),
//             text:
//               '[1] RE: 對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維'
//           }
//         ]
//       }
//     ],
//     revisions: [
//       {
//         ts: moment(faker.date.recent()),
//         text:
//           '[0] 對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維'
//       },
//       {
//         ts: moment(faker.date.recent()),
//         text:
//           '[1] 對於視覺設計出身相當受用，清楚建立許多觀念，並了解前端設計的思維'
//       }
//     ]
//   }
// ]

interface IState {
  entities: any[]
}
export default createModel({
  state: {
    entities: []
  },
  reducers: {
    updateEntities: (state: IState, entities: any[]) => ({ ...state, entities })
  },
  effects: {
    async fetchDiscussions() {
      const rootState = store.getState()
      const lectureId = rootState.lectureContent.currentLectureId
      if (!lectureId) {
        return
      }
      const ref = await firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .collection('discussions')
        .get()
      const discussions = await Promise.all(
        ref.docs.map(async doc => {
          const data = doc.data()
          data.id = doc.id
          data.ts = moment(data.ts.toDate())
          const repliesRef = await firebase
            .firestore()
            .collection('lectures')
            .doc(lectureId)
            .collection('discussions')
            .doc(doc.id)
            .collection('replies')
            .get()
          data.replies = repliesRef.docs.map(replyDoc => {
            const reply = replyDoc.data()
            reply.id = replyDoc.id
            reply.ts = moment(reply.ts.toDate())
            return reply
          })
          return data
        })
      )
      // update state
      this.updateEntities(discussions)
    },
    async createDiscussion({ text }: { text: string }) {
      const rootState = store.getState()
      const lectureId = rootState.lectureContent.currentLectureId
      const currentUser = firebase.auth().currentUser
      if (!lectureId || !currentUser) {
        return
      }
      const discussion = {
        ts: firebase.firestore.Timestamp.now(),
        text,
        authorId: currentUser.uid,
        reactions: {
          love: []
        },
        replies: [],
        revisions: []
      }
      firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .collection('discussions')
        .add(discussion)
        .then(this.fetchDiscussions)
    },
    async updateDiscussion({
      discussionId,
      text
    }: {
      discussionId: string;
      text: string;
    }) {
      const rootState = store.getState()
      const lectureId = rootState.lectureContent.currentLectureId
      if (!lectureId) {
        return
      }
      firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .collection('discussions')
        .doc(discussionId)
        .update({ text })
        .then(this.fetchDiscussions)
    },
    async replyDiscussion({
      discussionId,
      text
    }: {
      discussionId: string;
      text: string;
    }) {
      const rootState = store.getState()
      const lectureId = rootState.lectureContent.currentLectureId
      const currentUser = firebase.auth().currentUser
      if (!lectureId || !currentUser) {
        return
      }
      const reply = {
        ts: firebase.firestore.Timestamp.now(),
        text,
        authorId: currentUser.uid,
        reactions: {
          love: []
        },
        revisions: []
      }
      firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .collection('discussions')
        .doc(discussionId)
        .collection('replies')
        .add(reply)
        .then(this.fetchDiscussions)
    },
    async updateReply({
      discussionId,
      replyId,
      text
    }: {
      discussionId: string;
      replyId: string;
      text: string;
    }) {
      const rootState = store.getState()
      const lectureId = rootState.lectureContent.currentLectureId
      if (!lectureId) {
        return
      }
      firebase
        .firestore()
        .collection('lectures')
        .doc(lectureId)
        .collection('discussions')
        .doc(discussionId)
        .collection('replies')
        .doc(replyId)
        .update({ text })
        .then(this.fetchDiscussions)
    }
  }
})



// WEBPACK FOOTER //
// ./src/models/lectureDiscussion.ts